import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { baseApi } from '@/shared/api/baseApi.js';
import authReducer from '@/features/auth/authSlice.js';
import uiReducer from '@/features/ui/uiSlice.js';
import uploadsReducer from '@/features/chat/uploadsSlice.js';
import callsReducer from '@/features/calls/callsSlice.js';
import estimateHistoryReducer from '@/store/estimateHistory.slice.js';

export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    auth: authReducer,
    ui: uiReducer,
    uploads: uploadsReducer,
    calls: callsReducer,
    estimateHistory: estimateHistoryReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(baseApi.middleware),
  devTools: import.meta.env.DEV,
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
